module.exports = __webpack_public_path__ + "static/media/deal-gift-with-purchase.8dc86258.png";